import React from "react";
import { useParams } from "react-router-dom";
import QRCode from "qrcode.react";
import { Container, Box, Typography, Button, Paper } from "@mui/material";
import { styled } from "@mui/system";

const StyledContainer = styled(Container)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: theme.spacing(3),
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2),
  },
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  marginTop: theme.spacing(2),
  width: "100%",
  maxWidth: 400,
  textAlign: "center",
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2),
  },
}));

const Checkout = () => {
  const { transactionId } = useParams();

  const walletAddress = "0x7562d4d41a2b67e42141932287db358007fcc076";
  const coin = "USDT";
  const network = "BSC (BEP20)";

  const handleCopy = () => {
    navigator.clipboard
      .writeText(walletAddress)
      .then(() => {
        alert("Wallet address copied to clipboard");
      })
      .catch((err) => {
        alert("Failed to copy wallet address");
      });
  };

  return (
    <StyledContainer>
      <Typography variant="h4" gutterBottom>
        Deposit
      </Typography>
      <StyledPaper elevation={3}>
        <Typography variant="h6">Coin</Typography>
        <Typography variant="body1">{coin}</Typography>
        <Typography variant="h6" mt={2}>
          Network
        </Typography>
        <Typography variant="body1">{network}</Typography>
        <Box mt={2}>
          <QRCode value={walletAddress} size={256} />
        </Box>
        <Typography variant="h6" mt={2}>
          Wallet Address
        </Typography>
        <Typography variant="body1" style={{ wordBreak: "break-word" }}>
          {walletAddress}
        </Typography>
        <Typography variant="h6" mt={2}>
          Transaction ID
        </Typography>
        <Typography variant="body1">{transactionId}</Typography>
        <Button
          variant="contained"
          color="primary"
          style={{ marginTop: "16px" }}
          onClick={handleCopy}
        >
          Copy Address
        </Button>
      </StyledPaper>
    </StyledContainer>
  );
};

export default Checkout;
